import { Component, ElementRef, inject, Signal, signal, viewChild, WritableSignal } from '@angular/core';
import { IconComponent } from "@kinomap-dev/ng-ui-lib/basics";
import { ColorService } from '../../services/color.service';
import { FaqItem } from '../../types/faq-item.type';
import { FAQ_ITEMS } from '../../configs/faq/faq-items';
import { DashboardElement } from '../dashboard-element/dashboard-element';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-faq',
  imports: [TranslateModule, IconComponent, DashboardElement],
  templateUrl: './faq.html',
  styleUrl: './faq.scss',
  host: {}
})
export class Faq {
  colorService: ColorService = inject(ColorService);
  items: FaqItem[] = FAQ_ITEMS;
  activeIndex: WritableSignal<number | undefined> = signal(undefined);
  containerHeight: WritableSignal<number | null> = signal(null);
  hoveredIndex: WritableSignal<number | null> = signal(null);

  private panelsContainer = viewChild<ElementRef<HTMLDivElement>>('panelsContainer');

  openItem(index: number): void {
    const container = this.panelsContainer()?.nativeElement;
    if (container) {
      this.containerHeight.set(container.offsetHeight);
    }
    this.activeIndex.set(index);
  }

  closeItem(): void {
    this.activeIndex.set(undefined);
    setTimeout(() => this.containerHeight.set(null), 350);
  }

}
